import React, { useLayoutEffect, useRef, useState } from "react";
import "./ScaledPreview.scss";

const ScaledPreview = ({ width = 1080, maxHeight, className = "", children }) => {
  const outerRef = useRef(null);
  const innerRef = useRef(null);
  const [box, setBox] = useState({ scale: 0.4, height: 400 });

  useLayoutEffect(() => {
    const measure = () => {
      if (!outerRef.current || !innerRef.current) return;
      const scale = outerRef.current.clientWidth / width;
      setBox({ scale, height: innerRef.current.scrollHeight * scale });
    };
    measure();
    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(outerRef.current);
    observer.observe(innerRef.current);
    return () => observer.disconnect();
  }, [width]);

  const height = maxHeight ? Math.min(box.height, maxHeight) : box.height;

  return (
    <div
      ref={outerRef}
      className={`scaled-preview${maxHeight && box.height > maxHeight ? " is-cropped" : ""} ${className}`.trim()}
      style={{ height }}
      aria-hidden="true"
    >
      <div
        ref={innerRef}
        className="scaled-preview__inner agent-info-container"
        style={{ width, transform: `scale(${box.scale})` }}
      >
        {children}
      </div>
    </div>
  );
};

export default ScaledPreview;
